import { render, staticRenderFns } from "./restos.vue?vue&type=template&id=06f10322&scoped=true"
import script from "./restos.vue?vue&type=script&lang=js"
export * from "./restos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f10322",
  null
  
)

export default component.exports